import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../../services/api';

export interface AnalyticsState {
    data: any | null;
    isLoading: boolean;
    error: string | null;
}

const initialState: AnalyticsState = {
    data: null,
    isLoading: false,
    error: null,
};

export const fetchAnalytics = createAsyncThunk(
    'analytics/fetch',
    async (params: any, { rejectWithValue }) => {
        try {
            const data = await apiService.getAnalytics(params);
            return data;
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to fetch analytics');
        }
    }
);

const analyticsSlice = createSlice({
    name: 'analytics',
    initialState,
    reducers: {
        clearAnalyticsError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAnalytics.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchAnalytics.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
                state.error = null;
            })
            .addCase(fetchAnalytics.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload as string;
            });
    },
});

export const { clearAnalyticsError } = analyticsSlice.actions;

export const selectAnalytics = (state: { analytics: AnalyticsState }) => state.analytics.data;
export const selectAnalyticsLoading = (state: { analytics: AnalyticsState }) => state.analytics.isLoading;
export const selectAnalyticsError = (state: { analytics: AnalyticsState }) => state.analytics.error;

export default analyticsSlice.reducer;
